module.exports = __webpack_public_path__ + "a066669633ba20693484b5facb3bedff.pdf";